import React, { SVGProps } from "react";

export default function RmIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="38" height="38" x="1" y="1" fill="#FFF" rx="2" />
        <path
          fill="#FAC312"
          d="M24.11 37h12c.52 0 .94-.42.94-.94v-10l-1-1L24.11 37zM27.16 16.23L10.72 32.66 5.72 37 20.28 37 34.1 23.17zM36.06 3H17.77L36 21.26l1-1V3.94c0-.52-.42-.94-.94-.94z"
        />
        <path
          fill="#FAAC18"
          d="M13.93 3h-10c-.515.005-.93.425-.93.94v32.12c0 .52.42.94.94.94h1.78l5-4.34 16.44-16.43L13.93 3z"
        />
        <path
          fill="#FDE7AD"
          fillRule="nonzero"
          d="M13.93 3L37 26.07 37 22.23 17.77 3z"
        />
        <path
          fill="#FCC30E"
          fillRule="nonzero"
          d="M7.61 3v14.2c-1.626.47-2.733 1.974-2.695 3.667.037 1.692 1.21 3.146 2.855 3.543l-.16 11h2l.19-11.09c1.52-.506 2.546-1.928 2.546-3.53 0-1.602-1.026-3.024-2.546-3.53V3H7.61zm2.71 17.79c0 .688-.415 1.309-1.052 1.572-.636.262-1.368.115-1.854-.373-.485-.489-.628-1.222-.362-1.857.267-.634.89-1.046 1.578-1.042.45 0 .881.18 1.199.499.317.319.494.751.491 1.201z"
        />
        <path d="M7.61 23.48H9.81V35.41H7.61z" />
        <path d="M7.61 23.48H9.81V35.41H7.61z" />
        <path
          fill="#FEFEFE"
          fillRule="nonzero"
          d="M3.94 37h9.27L37 13.21V3.94c.01-.086.01-.174 0-.26L3.68 37c.086.01.174.01.26 0z"
        />
        <path
          fill="#EA5A60"
          fillRule="nonzero"
          d="M6.21 37h4.54L37 10.75V6.09L6.5 36.59c-.117.121-.214.26-.29.41z"
        />
        <path
          fill="#FDE7AD"
          fillRule="nonzero"
          d="M24.11 37L37 24.11 37 20.28 20.28 37z"
        />
        <path
          fill="#FEFEFE"
          fillRule="nonzero"
          d="M17 32.46c-1.643-.002-3.124-.992-3.753-2.51-.63-1.518-.286-3.265.873-4.43l8.19-8.2c1.59-1.59 4.17-1.59 5.76 0 1.59 1.59 1.59 4.17 0 5.76l-8.19 8.19c-.765.761-1.8 1.189-2.88 1.19z"
        />
        <path
          fill="#F9B67E"
          fillRule="nonzero"
          d="M26.9 18.52c-.931-.92-2.429-.92-3.36 0l-8.19 8.19c-.837.942-.795 2.373.096 3.264.891.89 2.322.933 3.264.096l8.19-8.19c.92-.931.92-2.429 0-3.36z"
        />
        <path
          fill="#FEFEFE"
          fillRule="nonzero"
          d="M13.07 6.81L14.4 6.81 16.25 10.44 16.25 10.44 18.11 6.81 19.43 6.81 19.43 13.81 17.83 13.81 17.83 10.47 17.83 10.47 16.75 12.65 15.75 12.65 14.67 10.47 14.67 10.47 14.67 13.81 13.07 13.81zM7.13 6.81h2.28c.71-.06 1.42.135 2 .55.496.444.752 1.097.69 1.76.02.455-.091.906-.32 1.3-.196.31-.477.556-.81.71l1.5 2.68H10.6l-1.19-2.4h-.63v2.4H7.13v-7zM9.44 10c.256.018.51-.053.72-.2.175-.177.263-.422.24-.67.03-.261-.067-.521-.26-.7-.24-.148-.52-.214-.8-.19h-.56V10h.66z"
        />
        <path
          fill="#E5E5E5"
          fillRule="nonzero"
          d="M37 1c1.105 0 2 .895 2 2v34c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h34m0-1H3C1.343 0 0 1.343 0 3v34c0 1.657 1.343 3 3 3h34c1.657 0 3-1.343 3-3V3c0-1.657-1.343-3-3-3z"
        />
      </g>
    </svg>
  );
}
